import { toast } from 'sonner';
import type { PtoRequest } from '../types/hr';
import { formatDays, formatRange } from './format';
import { hrActions } from './hrStore';

export function cancelMyRequest(request: PtoRequest) {
  hrActions.cancelRequest(request.id);
  toast('Request cancelled', {
    description: `${formatRange(request.start, request.end)} · ${formatDays(request.days)} returned to your available balance.`,
    action: { label: 'Undo', onClick: () => hrActions.restoreRequest(request.id) },
  });
}

export function maskSsn(ssn: string): string {
  return `***-**-${ssn.slice(-4)}`;
}

export function maskDob(iso: string): string {
  return `**/**/${iso.slice(0, 4)}`;
}

export function trimNumber(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
